import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyChooseUs from './components/WhyChooseUs';
import Challenges from './components/Challenges';
import Services from './components/Services';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className='App min-h-screen bg-white'>
      <Header />
      <main>
        <Hero />
        <WhyChooseUs />
        {/* Divider */}
        <div className='border-t-[2px] border-dashed border-[#9c9b9b]'></div>
        <Challenges />
        {/* Divider */}
        <div className='border-t-[2px] border-dashed border-[#9c9b9b]'></div>
        <Services />
      </main>
      <Footer />
    </div>
  );
}

export default App;
